import React from "react"

import Heading from "../Heading/Heading"
import Map from "./Map/map"

import classes from "./location.module.scss"

const Location = () => {
  return (
    <section className={classes.Location} id="location">
      <Heading>Ubicación</Heading>
      <p>
        Podés encontrarnos en la avenida <span>Manuel Ocampo</span> casi General
        Paz N° 1235
      </p>
      <div className={classes.Map}>
        <Map />
      </div>
      <a
        href="https://goo.gl/maps/QBfKn2eEahr2i43j9"
        target="_blank"
        rel="noreferrer"
        className={classes.Button}
      >
        Ver en Google Maps &rarr;
      </a>
    </section>
  )
}

export default Location
